const designRouter = [
  {
    path: '/constructionDelivery',
    name: 'constructionDelivery',
    component: () => import('@/views/wxapp/project-delivery/constructionDelivery'),
    meta: {
      title: '施工交付'
    },
    children: [
      // =====================shiqiong=========================
      {
        path: 'manager',
        name: 'managerService',
        component: () => import('@/views/wxapp/project-delivery/constructionDelivery/managerService'),
        meta: {
          title: '施工交付'
        }
      },
      {
        path: 'housekeeper',
        name: 'housekeeperService',
        component: () => import('@/views/wxapp/project-delivery/constructionDelivery/housekeeperService'),
        meta: {
          title: '施工交付'
        }
      },
      {
        path: 'technology',
        name: 'technology',
        component: () => import('@/views/wxapp/project-delivery/constructionDelivery/technology'),
        meta: {
          title: '施工交付'
        }
      },
      {
        path: 'details',
        name: 'details',
        component: () => import('@/views/wxapp/project-delivery/constructionDelivery/technology/details.vue'),
        meta: {
          title: '施工交付'
        }
      }
    ]
  }
]
export default designRouter
